import SignUpIcon from "../../assets/images/sign-up.png";
export default function SignUpImage() {
    return (
        <img src={SignUpIcon} className="img-fluid w-25 onbaordsignupimage" />
    )
} 